import { Controller } from "stimulus";

// Hides soft-deleted rows behind a "Show deleted" dropdown so the active ones
// stay in view, while keeping the deleted history one click away.
export default class extends Controller {
  static targets = ["row", "select", "count"];

  connect() {
    this.toggle();
  }

  toggle() {
    const show = this.hasSelectTarget && this.selectTarget.value === "yes";

    for (const row of this.rowTargets) {
      row.hidden = !show;
    }

    if (this.hasCountTarget) {
      this.countTarget.hidden = show || this.rowTargets.length === 0;
    }
  }
}
